import { useReducer } from "react";
import { initialState, AddFarmContextReducer } from "./add-farm-context-reducer";
import { AddFarmContext, AddFarmContextDispatch } from "./add-farm-context";

export const AddFarmContextProvider = ({ children }) => {
  const [context, dispatch] = useReducer(AddFarmContextReducer, initialState)

  return (
    <AddFarmContext.Provider value={context}>
      <AddFarmContextDispatch.Provider value={dispatch}>
        {children}
      </AddFarmContextDispatch.Provider>
    </AddFarmContext.Provider>
  )
}
